// Shared helpers for the wick-testing screens.
import axios from 'axios';

export const API = '/api/wick-tests';

export const LAB_BASE_URL = 'https://run.daydreamerconcepts.com';

export function labUrlFor(code) {
  return `${LAB_BASE_URL}/production/wick-test/${encodeURIComponent(code)}`;
}

// Short, label-friendly names: "VES-RW-Large Amber" -> "Large Amber",
// "OIL-RW-Spiked Cider" -> "Spiked Cider".
export function shortSku(sku) {
  return String(sku || '').replace(/^(VES|OIL|Wax|Wick)-(RW-|CF-)?/i, '').trim();
}

export function shortWax(sku) {
  const s = shortSku(sku);
  if (/titan/i.test(s)) return 'TitanWax 52114';
  return s;
}

export function fmtDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export const STATUS_LABEL = {
  untested: 'Not tested',
  queued: 'Queued to pour',
  poured: 'Poured',
  testing: 'In the lab',
  approved: 'Approved',
  failed: 'Failed round',
  cancelled: 'Cancelled',
};

// The operator's initials for lab readings, remembered on this device.
const OP_KEY = 'wickTestOperator';
export function getOperator() {
  try { return localStorage.getItem(OP_KEY) || ''; } catch (e) { return ''; }
}
export function setOperator(v) {
  try { localStorage.setItem(OP_KEY, v || ''); } catch (e) { /* private mode */ }
}

export const api = {
  settings: () => axios.get(`${API}/settings`).then((r) => r.data),
  saveSettings: (patch) => axios.put(`${API}/settings`, patch).then((r) => r.data),
  coverage: () => axios.get(`${API}/coverage`).then((r) => r.data),
  wicks: () => axios.get(`${API}/wicks`).then((r) => r.data),
  suggest: (vessel_sku, oil_sku) => axios.get(`${API}/suggest`, { params: { vessel_sku, oil_sku } }).then((r) => r.data),
  requests: (status, readings) => axios.get(`${API}/requests`, { params: { status, readings: readings ? 1 : undefined } }).then((r) => r.data.rows),
  request: (id) => axios.get(`${API}/requests/${id}`).then((r) => r.data),
  createRequests: (body) => axios.post(`${API}/requests`, body).then((r) => r.data),
  patchRequest: (id, patch) => axios.patch(`${API}/requests/${id}`, patch).then((r) => r.data),
  addCandidate: (id, body) => axios.post(`${API}/requests/${id}/candidates`, body).then((r) => r.data),
  removeCandidate: (id) => axios.delete(`${API}/candidates/${id}`).then((r) => r.data),
  // lab / pour station (public)
  pourSheet: () => axios.get(`${API}/lab/pour-sheet`).then((r) => r.data),
  markPoured: (id, by) => axios.post(`${API}/lab/requests/${id}/poured`, { by }).then((r) => r.data),
  labQueue: () => axios.get(`${API}/lab/queue`).then((r) => r.data.rows),
  candidate: (code) => axios.get(`${API}/lab/candidate/${encodeURIComponent(code)}`).then((r) => r.data),
  saveReading: (code, body) => axios.post(`${API}/lab/candidate/${encodeURIComponent(code)}/readings`, body).then((r) => r.data),
  deleteReading: (id) => axios.delete(`${API}/lab/readings/${id}`).then((r) => r.data),
  result: (code, body) => axios.post(`${API}/lab/candidate/${encodeURIComponent(code)}/result`, body).then((r) => r.data),
};
